// src/components/ServiceDetailSection.tsx
import React from "react";

interface ServiceDetailSectionProps {
  id: string;
  title: string;
  content: string[]; // Array of strings for paragraphs
}

const ServiceDetailSection: React.FC<ServiceDetailSectionProps> = ({
  id,
  title,
  content,
}) => {
  return (
    // Ensure mb-16 provides sufficient space between sections
    <section id={id} className="bg-white p-8 rounded-lg shadow-md mb-6 py-12">
      <h2 className="text-4xl font-semibold text-text-gray-darkest mb-4 border-b-2 border-accent-blue pb-2 inline-block">
        {" "}
        {/* Using custom colors */}
        {title}
      </h2>
      <div className="services-step-wrapper">
        <div className="services-step-content">
          {content.map((paragraph, index) => (
            <p
              key={index}
              className="text-lg text-text-gray-medium leading-relaxed mb-4"
            >
              {paragraph}
            </p>
          ))}
          {/* Special case for Email Marketing 'Get in touch' link */}
          {id === "email-marketing" && (
            <p className="text-lg text-text-gray-medium leading-relaxed mb-4">
              <a
                href="mailto:enquiry@elenoit.com"
                className="text-accent-blue hover:underline"
              >
                Get in touch
              </a>
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default ServiceDetailSection;
